import { cardGroups } from './base-components/display/card-groups';
import { CardGroup, Card, RenderCardEntry, DisplayCardEntry } from '@source-components-react/types';

let cachedSourceComponentsPlugin: { components: Record<string, RenderCardEntry> } | undefined;

const getComponentsFromRenderCardGroups = (group: CardGroup[]): Record<string, RenderCardEntry> => {
  const entries = group.flatMap(group => group.cards.flatMap((card: Card) => card.entries)) as DisplayCardEntry[];
  return entries.reduce(
    (acc, entry) => {
      acc[entry.id] = {
        id: entry.id,
        card: entry.card,
        defaultAttributeValues: entry.defaultAttributeValues,
        ...(entry.resolveNoContainer !== undefined ? { resolveNoContainer: entry.resolveNoContainer } : {}),
        ...(entry.noContainer !== undefined ? { noContainer: entry.noContainer } : {}),
        ...(entry.resolveRendersOwnElement !== undefined
          ? { resolveRendersOwnElement: entry.resolveRendersOwnElement }
          : {}),
      }
      return acc;
    },
    {} as Record<string, RenderCardEntry>
  );
};

/**
 * Returns the source components plugin with a lookup map of render components.
 * Results are cached after the first call.
 */
export const getSourceComponentsPlugin = () => {
  if (cachedSourceComponentsPlugin) {
    return cachedSourceComponentsPlugin;
  }

  const components = getComponentsFromRenderCardGroups(cardGroups);

  cachedSourceComponentsPlugin = {
    components,
  };

  return cachedSourceComponentsPlugin;
};